import { Col, Form, FormInstance, InputNumber, Row, Switch } from "antd";
import { useState } from "react";
import { EditEventFormType } from "../CreateOrEditEvent";
import CompanyCard from "./CompanyCard";

interface Props {
  form: FormInstance<EditEventFormType>;
}

const CompanyCardWaitlist: React.FC<Props> = ({ form }) => {
  const [waitingList, setWaitingList] = useState(form.getFieldValue("use_waiting_list"));

  const onChange = (checked: boolean) => {
    setWaitingList(checked);
    form.setFieldValue("use_waiting_list", checked);

    if (!checked) {
      form.setFieldValue("waiting_list_size", 0);
    } else {
      form.setFieldValue("waiting_list_size", 15);
    }
  };

  const onChangeSize = (value: number | null) => {
    form.setFieldValue("waiting_list_size", value);
  };
  const onChangeOverbooking = (value: number | null) => {
    form.setFieldValue("overbooking", value);
  };

  return (
    <CompanyCard title="Venteliste og overbooking">
      <Row>
        <Form.Item<EditEventFormType> name="use_waiting_list" label="Benytt venteliste" valuePropName="checked">
          <Switch checkedChildren="Ja" unCheckedChildren="Nei" onChange={onChange} style={{ width: "50px" }} />
        </Form.Item>
      </Row>
      <Row gutter={[30, 30]}>
        <Col md={12} xs={24}>
          <Form.Item<EditEventFormType>
            name="waiting_list_size"
            label="Antall ventelisteplasser"
            rules={[{ required: true, message: "Skriv inn antall ventelisteplasser" }]}
          >
            <InputNumber
              size="large"
              min={0}
              onChange={onChangeSize}
              style={{ width: "98%" }}
              disabled={!waitingList}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item<EditEventFormType>
            name="overbooking"
            label="Overbooking"
            rules={[{ required: true, message: "Angi ønsket overbooking" }]}
          >
            <InputNumber size="large" min={0} onChange={onChangeOverbooking} addonAfter="%" style={{ width: "98%" }} />
          </Form.Item>
        </Col>
      </Row>
    </CompanyCard>
  );
};

export default CompanyCardWaitlist;
